import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../components/AuthProvider";
import { loginPayload } from "../../components/entities/auth.payload";
import _ from "lodash";

function Login() {

    const { handleLoginUser } = useAuthContext();

    const [payload, setPayload] = useState(loginPayload());

    useEffect(() => {

        const togglePassword = document.querySelector("#togglePassword");
        const password = document.querySelector("#login-password");

        const handleClick = function () {

            const type = password.getAttribute("type") === "password" ? "text" : "password";
            password.setAttribute("type", type);
            this.classList.toggle('fa-eye');
            this.classList.toggle('fa-eye-slash');
        };

        togglePassword.addEventListener("click", handleClick);

        return () => togglePassword.removeEventListener("click", handleClick);
    }, []);

    const handlChange = (e) => {

        const { name, value } = e.target;

        setPayload({ ...payload, [name]: value });
    }

    const submitLogin = (e) => {
        e.preventDefault();

        handleLoginUser(_.cloneDeep(payload));
    }

    return (
        <div className="card">
            <div className="card-header bg-circle-shape bg-shape text-center p-2"><a className="font-sans-serif fw-bolder fs-5 z-1 position-relative link-light" href="#/" data-bs-theme="light">Cirrus Oil</a></div>
            <div className="card-body p-4">
                <div className="row flex-between-center">
                    <div className="col-auto">
                        <h3>Login</h3>
                    </div>
                </div>
                <form id="frmLogin" onSubmit={submitLogin}>
                    <div className="mb-3">
                        <label className="form-label" htmlFor="login-email">Email address</label>
                        <input className="form-control" id="login-email" type="email"
                            value={payload.email} onChange={handlChange} name="email" />
                    </div>
                    <div className="mb-3">
                        <div className="d-flex justify-content-between">
                            <label className="form-label" htmlFor="login-password">Password</label>
                        </div>
                        <div className="input-group">
                            <input className="form-control" id="login-password" type="password"
                                style={{ borderRight: 'none' }}
                                value={payload.password} onChange={handlChange} name="password" />
                            <span className="input-group-text" style={{ backgroundColor: '#ffffff', borderLeft: 'none' }}
                                role="button"><i className="fas fa-eye" id="togglePassword" /></span>
                        </div>
                    </div>
                    <div className="row flex-between-center">
                        <div className="col-auto">
                            <div className="form-check mb-0">
                            </div>
                        </div>
                        <div className="col-auto">
                        </div>
                    </div>
                    <div className="mb-3">
                        <button className="btn btn-primary d-block w-100 mt-3" type="submit" name="submit">
                            Log in
                        </button>
                    </div>
                </form>
                <div className="position-relative mt-4">
                    <hr />
                </div>
            </div>
        </div>
    );
}

export default Login;
